$(() => {
    $('.proxy-login').on('click', function () {
        const form = $(this).closest("#proxy_login_form");
        if (form) {
            $.ajax({
                type: 'POST',
                url: '/admin/proxy_token',
                data: {
                    'user_id': form.data('userId'),
                },
                dataType: 'json'
            }).done((data) => {
                form.find("input[name='token']").val(data.token);
                form.submit();
            });
        }
    });
});
